export * from './globals';
export * from './isInternalUrl';
export * from './createSlug';
export * from './getTwoLetterLanguageCode';
export * from './fp';
export * from './registrationForm';
export * from './currency';
export * from './geolocation';
export * from './isHomePage';

import { getTwoLetterLanguageCode } from './getTwoLetterLanguageCode';

export const homepageLink = (languageCode: string) => {
    return { url: `/${getTwoLetterLanguageCode(languageCode)}/` };
};
